export default {"src":"/_next/static/media/square-pattern-white.b84cfa16.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};